import { render, staticRenderFns } from "./navigation-menu.component.vue?vue&type=template&id=775eaff4"
import script from "./navigation-menu.component.vue?vue&type=script&lang=ts"
export * from "./navigation-menu.component.vue?vue&type=script&lang=ts"
import style0 from "./navigation-menu.component.vue?vue&type=style&index=0&id=775eaff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports